<template>
  <div class="button-group">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VButtonGroup',
};
</script>

<style lang="scss" scoped>
.button-group {
  display: block;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;

  &:not(:first-child),
  ::v-deep .button {
    &:not(:first-child) {
      margin-top: 25px;
    }
  }
}
</style>
